import React from 'react';

const warehouseImages = [
    {
        id: 1,
        title: "",
        description: "",
        image: "https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482285/IMG-20250530-WA0033_adfwhb.jpg"
    },
    {
        id: 2,
        title: "",
        description: "",
        image: "https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482294/IMG-20250530-WA0049_m5oxfd.jpg"
    },
    {
        id: 3,
        title: "",
        description: "",
        image: "https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482296/IMG-20250530-WA0055_injgak.jpg"
    },
    {
        id: 4,
        title: "",
        description: "",
        image: "https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482288/IMG-20250530-WA0039_u1ii9l.jpg"
    },
    {
        id: 5,
        title: "",
        description: "",
        image: "https://res.cloudinary.com/dgtbjxhqs/image/upload/v1749482289/IMG-20250530-WA0042_ypuhr7.jpg"
    }
];

export default function WareHouse() {
  return (
    <div className="container mx-auto px-4 py-16 mt-8">
      <h2 className="text-4xl font-bold text-left mb-12 mt-12">
        Dari Warehouse & Distribution
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {warehouseImages.map((item, index) => (
          <div
            key={item.id}
            className={`relative group overflow-hidden rounded-xl shadow-lg ${
              item.id === 1 ? 'md:col-span-3 lg:col-span-1' : ''
            }`}
            style={{ height: item.id === 1 ? '500px' : '400px' }}
          >
            <div
              className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
              style={{ backgroundImage: `url(${item.image})` }}
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <div className="absolute inset-0 p-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end">
              <h3 className="text-2xl font-bold mb-2">{item.title}</h3>
              <p className="text-sm mb-2">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-16 bg-gray-100 p-8 rounded-lg">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-xl font-semibold mb-2">Storage Solutions</h4>
            <p>Climate-controlled facilities with advanced security systems for safe storage of all types of goods.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-xl font-semibold mb-2">Distribution</h4>
            <p>Nationwide logistics network ensuring timely delivery across all 36 states of Nigeria.</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h4 className="text-xl font-semibold mb-2">Inventory Management</h4>
            <p>Real-time tracking and digital inventory control systems for maximum efficiency.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
